// src/store/useBreakoutStore.js
import { create } from "zustand";

const useBreakoutStore = create((set, get) => ({
    // ==================== STATE ====================
    breakoutId: null,
    isOwner: false,
    livekitRoomName: null,
    livekitToken: null,
    livekitServerUrl: null,
    expiresAt: null,
    timeLimitMinutes: null,
    participants: [],
    isActive: false,
    sessionId: null,

    // Invite state (for invited user)
    pendingInvite: null, // { breakoutId, ownerName, ownerImage, timeLimitMinutes, expiresAt }

    // Owner disconnect state
    ownerDisconnected: false,
    gracePeriodSeconds: 0,

    // ==================== ACTIONS ====================

    /**
     * Set breakout data after creating or joining
     */
    setBreakout: (data) =>
        set({
            breakoutId: data.breakoutId,
            isOwner: data.isOwner || false,
            livekitRoomName: data.livekitRoomName,
            livekitToken: data.livekitToken,
            livekitServerUrl: data.livekitServerUrl,
            expiresAt: data.expiresAt,
            timeLimitMinutes: data.timeLimitMinutes,
            sessionId: data.sessionId || get().sessionId,
            isActive: true,
        }),

    /**
     * Clear breakout state (on leave/end)
     */
    clearBreakout: () =>
        set({
            breakoutId: null,
            isOwner: false,
            livekitRoomName: null,
            livekitToken: null,
            livekitServerUrl: null,
            expiresAt: null,
            timeLimitMinutes: null,
            participants: [],
            isActive: false,
            sessionId: null,
            ownerDisconnected: false,
            gracePeriodSeconds: 0,
        }),

    /**
     * Set pending invite
     */
    setPendingInvite: (invite) => set({ pendingInvite: invite }),

    /**
     * Clear pending invite
     */
    clearPendingInvite: () => set({ pendingInvite: null }),

    /**
     * Set participants list
     */
    setParticipants: (participants) => set({ participants }),

    /**
     * Add a participant
     */
    addParticipant: (participant) =>
        set((state) => ({
            participants: [
                ...state.participants.filter((p) => p.userId !== participant.userId),
                participant,
            ],
        })),

    /**
     * Remove a participant
     */
    removeParticipant: (userId) =>
        set((state) => ({
            participants: state.participants.filter((p) => p.userId !== userId),
        })),

    /**
     * Set owner disconnected state
     */
    setOwnerDisconnected: (disconnected, gracePeriodSeconds = 60) =>
        set({
            ownerDisconnected: disconnected,
            gracePeriodSeconds: disconnected ? gracePeriodSeconds : 0,
        }),

    /**
     * Set session ID
     */
    setSessionId: (sessionId) => set({ sessionId }),
}));

export default useBreakoutStore;